import { HttpHelper, HttpServiceParams } from 'rbh-merchant-core';
import { MAIN_REQUEST_ID_LIST } from './main-constant';
import { envConfig } from '../config';

class MainServiceClass {
  getMasterData = async (params: any) => {
    return await HttpHelper.get({
      url: envConfig.hostname + 'v1/merchant/master/classifications',
      id: MAIN_REQUEST_ID_LIST.GET_MASTER_DATA
    });
  }

  postConfirmAllChange = async (params: HttpServiceParams) => {
    return await HttpHelper.post({
      url: `${envConfig.hostname}v1/merchant/company-admin/confirm`,
      data: params.data,
      id: MAIN_REQUEST_ID_LIST.POST_CONFIRM_ALL_CHANGE
    });
  }

  getPreload = async () => {
    return await HttpHelper.get({
      url: 'v1/merchant/company-admin/preload',
      id: MAIN_REQUEST_ID_LIST.GET_PRELOAD
    });
  }
}

export const MainService = new MainServiceClass();
